var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.7113 5.28993L12.7586 0.295375C12.368 -0.0984528 11.7349 -0.0984636 11.3444 0.295375C10.9538 0.689213 10.9538 1.3277 11.3444 1.72153L14.5954 5L1 5C0.447715 5 0 5.44772 0 6C0 6.55229 0.447716 7 1 7L14.5954 7L11.3444 10.2785C10.9538 10.6723 10.9538 11.3108 11.3444 11.7046C11.7349 12.0984 12.368 12.0985 12.7586 11.7046L17.7113 6.71008C18.1002 6.31791 18.1002 5.68209 17.7113 5.28993Z"}));
}

ArrowInline.defaultProps = {"width":"19","height":"12","viewBox":"0 0 19 12"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
